const apiKey = "VdkxFjVwL1TY8ixo";
// const apiKey = "DPyF4KAdI0F2cGT6"
export default apiKey;
